import { ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/i18n";
import GoogleGlyph from "@/components/sections/review/GoogleGlyph";

export default function ReviewAction({ ctaLabel, subnote }) {
  return (
    <div className="lg:col-span-5 lg:text-right">
      <a
        href={COMPANY.googleReviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary inline-flex whitespace-nowrap"
        data-testid="google-review-btn"
      >
        <GoogleGlyph />
        {ctaLabel}
        <ArrowUpRight className="w-5 h-5" />
      </a>
      <p className="text-white/55 text-xs mt-4">{subnote}</p>
    </div>
  );
}
